import { FC, SVGProps } from 'react'

import { AppIcon, Icon, isAppIcon } from '../../assets/icons'

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  isDisabled?: boolean
  icon: AppIcon | FC<SVGProps<SVGSVGElement>>
  ariaLabel: string
}

export const IconButton = ({
  ariaLabel,
  isDisabled,
  icon: PropsIcon,
  ...props
}: Props) => {
  return (
    <button
      {...props}
      aria-label={ariaLabel}
      className="flex h-10 w-10 items-center justify-center rounded border border-blue-500 p-0 text-blue-500 hover:bg-blue-100 hover:text-blue-500 disabled:border-gray-300 disabled:bg-gray-50 disabled:text-gray-300"
      disabled={isDisabled}
      type="button"
    >
      {isAppIcon(PropsIcon) ? (
        <Icon name={PropsIcon} />
      ) : (
        <PropsIcon aria-hidden="true" className="h-5 w-5" />
      )}
    </button>
  )
}
